import React from 'react';
import Lozenge from '@atlaskit/lozenge';
import { StyledChild, StyledItem, StyledOption } from '../../../common/ui/styled';
export var LozengeOptionLabel = function LozengeOptionLabel(_ref) {
  var lozengeOption = _ref.lozengeOption;
  return /*#__PURE__*/React.createElement(StyledOption, null, /*#__PURE__*/React.createElement(StyledChild, null, /*#__PURE__*/React.createElement(StyledItem, null, /*#__PURE__*/React.createElement(Lozenge, {
    appearance: lozengeOption.appearance,
    isBold: lozengeOption.isBold,
    maxWidth: lozengeOption.maxWidth
  }, lozengeOption.label))));
};